import React, { useState } from 'react';
import { MailCheck } from 'lucide-react';
import { auth } from '../config/firebase';
import { useAuth } from '../context/AuthContext';
import { mensajeErrorAuth } from '../utils/authErrores';

/**
 * Aviso para quien entra con email y contraseña y aún no ha confirmado el
 * email. Hasta que lo haga, entrar con Apple o Google con ese mismo email
 * deja solo ese método: Firebase quita la contraseña y los demás vínculos.
 */
export const AvisoVerificarEmail: React.FC = () => {
  const { emailSinVerificar, enviarVerificacion, comprobarVerificacion } = useAuth();
  const [ocupado, setOcupado] = useState<'enviar' | 'comprobar' | null>(null);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');

  if (!emailSinVerificar) return null;

  const accion = async (clave: 'enviar' | 'comprobar') => {
    setOcupado(clave); setError(''); setMensaje('');
    try {
      if (clave === 'enviar') {
        await enviarVerificacion();
        setMensaje('Te lo hemos enviado. Mira también en correo no deseado.');
      } else if (!(await comprobarVerificacion())) {
        setError('Todavía no consta. Pulsa el enlace del correo y vuelve a probar.');
      }
    } catch (e) {
      setError(mensajeErrorAuth(e, 'No se ha podido completar. Inténtalo más tarde.'));
    } finally {
      setOcupado(null);
    }
  };

  const boton = 'text-xs font-semibold px-3 py-2 rounded-lg transition disabled:opacity-50';

  return (
    <div className="max-w-7xl mx-auto px-4 pt-4">
      <div role="status" className="flex gap-3 rounded-xl border border-amber-200 dark:border-amber-700
                      bg-amber-50 dark:bg-amber-900/20 px-4 py-3">
        <MailCheck className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-amber-900 dark:text-amber-200">Confirma tu email</p>
          <p className="text-xs text-amber-800 dark:text-amber-300 mt-0.5 break-words">
            Te enviamos un enlace a <strong>{auth.currentUser?.email}</strong>. Hasta que lo pulses, si entras
            con Apple o Google con ese email perderás la contraseña como forma de entrar.
          </p>
          <div className="flex flex-wrap gap-2 mt-2">
            <button type="button" onClick={() => accion('comprobar')} disabled={ocupado !== null}
              className={`${boton} bg-amber-600 hover:bg-amber-700 text-white`}>
              {ocupado === 'comprobar' ? 'Comprobando…' : 'Ya lo he confirmado'}
            </button>
            <button type="button" onClick={() => accion('enviar')} disabled={ocupado !== null}
              className={`${boton} border border-amber-300 dark:border-amber-700 text-amber-800 dark:text-amber-200
                          hover:bg-amber-100 dark:hover:bg-amber-900/40`}>
              {ocupado === 'enviar' ? 'Enviando…' : 'Reenviar correo'}
            </button>
          </div>
          {mensaje && <p className="text-xs text-amber-800 dark:text-amber-300 mt-2">{mensaje}</p>}
          {error && <p className="text-xs text-red-600 dark:text-red-400 mt-2">{error}</p>}
        </div>
      </div>
    </div>
  );
};
